import * as React from 'react';
import { trackError } from '../react/services/TrackJs';
import history from './history';

interface Props {
    errorComponent: React.ComponentType<{ error: unknown }>;
}

export default class RouteErrorBoundary extends React.Component<React.PropsWithChildren<Props>, { error: unknown }> {
    state = {
        error: null,
    };

    onUnmount?: () => void;

    static getDerivedStateFromError(error: unknown) {
        return { error };
    }

    componentDidCatch(error: any) {
        trackError(error);
    }

    componentDidMount() {
        this.onUnmount = history?.listen(() => {
            if (this.state.error) {
                this.setState({ error: null });
            }
        });
    }

    componentWillUnmount() {
        this.onUnmount?.();
    }

    render() {
        const { errorComponent: ErrorComponent } = this.props;

        if (this.state.error) {
            return <ErrorComponent error={this.state.error} />;
        }

        return this.props.children;
    }
}
